import {schema} from 'normalizr'
import {channelSchema} from './channel'
import {userSchema} from './user'

export const organizationSchema = new schema.Entity(
    'organizations',
    {
        channels: [channelSchema],
        creator: userSchema
    },
    {
        idAttribute: 'idname'
    }
)
export const organizationSchemaArray = [
    organizationSchema
]


export const organizationDepartmentSchema = new schema.Entity(
    'organization_departments',
    {},
    {
        idAttribute: 'id',
    }
)
export const organizationDepartmentMemberSchema = new schema.Entity(
    'organization_department_member',
    {},
    {
        idAttribute: 'id',
    }
)

export const organizationAnnouncementSchema = new schema.Entity(
    'organization_announcements',
    {},
    {
        idAttribute: 'id',
    }
)